"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHover = useHover;
const react_aria_1 = require("react-aria");
// Handles hover pointer interactions for an element.
function useHover(props) {
    const { disabled: isDisabled, ...others } = props;
    return (0, react_aria_1.useHover)({ isDisabled, ...others });
}
